<template>
  <section class="page-block">
    <div class="block-header">
      <h3 class="title">{{ title }}</h3>
      <img src="../assets/images/block-top.svg" alt="">
    </div>
    <slot></slot>
    <img class="angle left-top" src="../assets/images/left-top.svg" alt="">
    <img class="angle right-top" src="../assets/images/right-top.svg" alt="">
    <img class="angle left-bottom" src="../assets/images/left-bottom.svg" alt="">
    <img class="angle right-bottom" src="../assets/images/right-bottom.svg" alt="">
  </section>
</template>

<script>
export default {
  name: 'page-block',
  props: {
    title: String
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.page-block {
  border: 2px solid rgba(102, 255, 255, 0.3);
  padding: 12px;
  position: relative;
  .block-header{
    .title{
      margin: 0;
      font-size: 19.96px;
      font-weight: bold;
      line-height: 19.96px;
      text-align: left;
      color: #fff;
      padding-left: 8px;
    }
    img{
      padding-left: 8px;
    }
  }
  .angle{
    position: absolute;
    &.left-top{
      left: -2px;
      top: -2px;
    }
    &.right-top{
      right: -2px;
      top: -2px;
    }
    &.left-bottom{
      left: -2px;
      bottom: -2px;
    }
    &.right-bottom{
      right: -2px;
      bottom: -2px;
    }
  }
}
</style>
